export default {
  name: 'classroom',
  data () {
    return {

    }
  },
  methods: {
    handleMyClassroom () {
      location.href = 'https://study.gecacademy.cn/classroom'
    }
  }
}



// WEBPACK FOOTER //
// ./src/components/classroom/classroom.js